import { LogErrors } from './../../LogErrors'

import { GetAllResults as BLGetAllResults, GetFilteredResults as BLGetFilteredResults, GetReportDetails as DLGetReportDetails, GetQuestionDetail as DLGetQuestionDetail } from './../../DL/Instructor/Results' //GetDetailedResults as BLGetDetailedResults


const GetAllResults = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const center = userData?.navigation?.center?.id
        if (!center) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
        
        const response = await BLGetAllResults(center, token)
        
        if (response.success) {
            const evaluations = []
            
            // Recopilar evaluaciones con información necesaria
            response.data.forEach(evaluation => {
                // {
                //     "groupName": "año 2025",
                //     "courseName": "Excel",
                //     "name": "Carmen",
                //     "lastName": "Soto",
                //     "email": "carmen@mail.com",
                //     "user": "Carmen",
                //     "blockName": "Evaluación parcial de Interacción con hojas de cálculo"
                //     "attemptNumber": 2,
                //     "finishDate": "2025-08-09T02:51:36+00:00",
                //     "score": 1000
                // }

                let element = {
                    groupName: evaluation.groupName,
                    courseName: evaluation.levelName
                        ? `${evaluation.courseName ?? ''} (Nivel ${evaluation.levelName})`
                        : evaluation.courseName,
                    name: evaluation.name,
                    lastName: evaluation.lastName,
                    email: evaluation.email,
                    user: evaluation.user,
                    blockName: evaluation.blockName,
                    attemptNumber: evaluation.attemptNumber,
                    finishDate: evaluation.finishDate,
                    score: evaluation.score
                }
                
                evaluations.push(element)
            })
            
            return { success: true, data: evaluations }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAllResults - BL', error)
    }
}

const GetFilteredResults = async (filterData) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
    
        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const center = userData?.navigation?.center?.id
        if (!center || isNaN(center)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
        
        const group = filterData?.groupId
        if (!group || isNaN(group)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const course = filterData?.courseId
        if (!course || isNaN(course)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const block = filterData?.evaluationId
        if (!block || isNaN(block)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const ztudent = filterData?.ztudent
        if (ztudent) {
            if (isNaN(ztudent)) {
                return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
            }
        }

        const page = filterData?.pageNumber
        if (!page || isNaN(page)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
        
        const pageSize = filterData?.pageSize
        if (!pageSize || isNaN(pageSize)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
        
        const returnAll = filterData?.returnAll === true
        const attemptScoreFilter = filterData?.attemptScoreFilter ?? 0

        const response = await BLGetFilteredResults(center, group, course, block, ztudent, page, pageSize, token, returnAll, attemptScoreFilter)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetFilteredResults - BL', error)
    }
}

const GetReportDetails = async (evaluationData) => {
    try {


        // idCenter: centerInfo.idCenter ?? row.idCenter ?? null,
        // centerName: centerInfo.centerName ?? row.centerName ?? '',
        // studentId: row.idZtudiante ?? row.studentId ?? row.id ?? null,
        // courseId: row.idCourse ?? selectedCourseId ?? null,
        // token: row.token,
        // groupId: row.idGroup ?? selectedGroupId ?? null,
        // groupName: groupNameFromState,
        // attemptNumber: row.attemptNumber ?? 1


        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }

        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter || isNaN(idCenter)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        // El flujo de selección de centro/rol (SaveCenterAndRoleToShow) solo persiste el id del
        // centro en la sesión, nunca su nombre. Exigirlo aquí bloqueaba siempre la exportación
        // individual sin que la fila ni la sesión tuvieran ningún dato realmente faltante.
        const centerName = userData?.navigation?.center?.name ?? ''

        const student = evaluationData?.studentId
        if (!student || isNaN(student)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const course = evaluationData?.courseId
        if (!course || isNaN(course)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const groupId = evaluationData?.groupId
        if (!groupId || isNaN(groupId)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const groupName = evaluationData?.groupName
        if (!groupName) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const attemptNumber = evaluationData?.attemptNumber
        if (!attemptNumber || isNaN(attemptNumber)) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }

        const evaluationToken = evaluationData?.evaluationToken
        if (!evaluationToken) {
            return { success: false, message: 'No se encontró lo necesario para generar el reporte solicitado.' }
        }
        
        const response = await DLGetReportDetails(idCenter, centerName, student, course, groupId, groupName, attemptNumber, evaluationToken, token)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetDetailedResults - BL', error)
    }
}

/**
 * Obtiene el detalle pregunta por pregunta de un intento finalizado de un estudiante.
 */
const GetQuestionDetail = async (evaluationData) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const idCenter = userData?.navigation?.center?.id
        if (!idCenter || isNaN(idCenter)) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const studentId = evaluationData?.studentId
        if (!studentId || isNaN(studentId)) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const courseId = evaluationData?.courseId
        if (!courseId || isNaN(courseId)) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const evaluationToken = evaluationData?.evaluationToken
        if (!evaluationToken) {
            return { success: false, message: 'No se encontró lo necesario para generar el detalle solicitado.' }
        }

        const response = await DLGetQuestionDetail(idCenter, studentId, courseId, evaluationToken, token)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetQuestionDetail - BL Results', error)
        return { success: false, message: 'Error interno al obtener el detalle de la evaluación.' }
    }
}

/**
 * Convierte una fecha ISO (ej. "2025-09-30T21:03:12")
 * al formato "30/09/2025 21:03:12 hrs."
 *
 * @param {string} isoDate - Fecha en formato ISO.
 * @returns {string} Fecha formateada.
 */
const FormatDateTime = (isoDate) => {
  try {
    if (!isoDate) return ""

    const date = new Date(isoDate)

    const day = String(date.getUTCDate()).padStart(2, "0")
    const month = String(date.getUTCMonth() + 1).padStart(2, "0")
    const year = date.getUTCFullYear()

    const hours = String(date.getUTCHours()).padStart(2, "0")
    const minutes = String(date.getUTCMinutes()).padStart(2, "0")
    const seconds = String(date.getUTCSeconds()).padStart(2, "0")

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} hrs.`
  } catch {
    return ""
  }
}

// const FormatDateTime = (isoDate) => {
//     try {
//         if (!isoDate) return ""

//         const date = new Date(isoDate)

//         const day = String(date.getDate()).padStart(2, "0")
//         const month = String(date.getMonth() + 1).padStart(2, "0")
//         const year = date.getFullYear()

//         const hours = String(date.getHours()).padStart(2, "0")
//         const minutes = String(date.getMinutes()).padStart(2, "0")
//         const seconds = String(date.getSeconds()).padStart(2, "0")

//         return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} hrs.`
//     } catch (error) {
        
//     }
// }

export { GetAllResults, GetFilteredResults, GetReportDetails, GetQuestionDetail, FormatDateTime }; //GetDetailedResults